
import React, { useState } from "react";
import UpcomingBooking from "./UpcomingBooking";
import CompletedBooking from "./CompletedBooking";


 const MyBooking = () => {

  const [activeButton, setActiveButton] = useState("hourly");
  return (
    <>
    <div className="border rounded-lg">
      <div className="w-full  flex items-start justify-center mt-6">
        <div className="w-full h-auto flex flex-col items-center justify-center  gap-12">         
          <div className="flex space-x-4 bg-[#FFF2C6] p-1 rounded-xl">
            <button
              onClick={() => setActiveButton("hourly")}
              className={`py-1 px-6 rounded-full ${
                activeButton === "hourly" ? "bg-[#FF9630] text-white" : "text-gray-600"
              }`}

            >
              UpComing
            </button>

            <button
              onClick={() => setActiveButton("subscription")}
              className={`py-1 px-6 rounded-full ${
                activeButton === "subscription" ? "bg-[#FF9630] text-white" : "text-gray-600"
              }`}
            >
             Completed
            </button>
          </div>
        </div>
      </div>

      {/* Conditional Rendering */}
      <div className="flex justify-center mt-6">
        {activeButton === "hourly" ? <UpcomingBooking/> : <CompletedBooking/>}
      </div>
      </div>
    </>
  );
};

export default MyBooking;
